import { RouteSectionProps } from "@solidjs/router";

import DashboardLayout, { Tab } from "@repo/ui/dashboard/DashboardLayout";

export default function Dashboard({ children }: D<RouteSectionProps>) {
  return (
    <DashboardLayout
      tabs={
        <>
          <Tab path="/users" long="User search" icon="" short="Users" />
          <Tab path="/manual-idv" long="Manual IDV" icon="" short="IDV" />
          <Tab
            path="/furnishing"
            long="Furnishing"
            icon=""
            short="Furnishing"
          />
        </>
      }
      propsFor={{
        logo: {
          variant: "icon",
          children: "Admin",
        },
      }}
    >
      {children}
    </DashboardLayout>
  );
}
